import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgQuoteIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 8.467 5.556"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      style={{
        fill: "#000",
      }}
      transform="matrix(.26458 0 0 .26458 -3.175 -4.498)"
    >
      <circle
        style={{
          fill: "#000",
        }}
        cx={18.5}
        cy={31.5}
        r={5.5}
      />
      <path
        style={{
          fill: "#000",
        }}
        d="M18.5 38a6.508 6.508 0 0 1-6.5-6.5c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5Z"
      />
    </g>
    <g
      style={{
        fill: "#000",
      }}
      transform="matrix(.26458 0 0 .26458 -3.175 -4.498)"
    >
      <circle
        style={{
          fill: "#000",
        }}
        cx={35.5}
        cy={31.5}
        r={5.5}
      />
      <path
        style={{
          fill: "#000",
        }}
        d="M35.5 38a6.508 6.508 0 0 1-6.5-6.5c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5Z"
      />
    </g>
    <path
      style={{
        fill: "#000",
        strokeWidth: 0.264583,
      }}
      d="M95.136 111.622a.264.264 0 0 1-.264-.265 3.708 3.708 0 0 1 3.704-3.704.264.264 0 1 1 0 .53 3.179 3.179 0 0 0-3.175 3.174.264.264 0 0 1-.265.265zM103.074 107.653a3.708 3.708 0 0 0-3.705 3.704.264.264 0 1 0 .53 0 3.179 3.179 0 0 1 3.175-3.175.264.264 0 1 0 0-.529z"
      transform="translate(-94.872 -107.653)"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgQuoteStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgQuoteIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const QuoteIcon: any = SvgQuoteStyle;
export default QuoteIcon;
